import leadConverionsAnalyticsService from 'services/lead-conversions-analytics-service'

// ------------------------------------
// Constants
// ------------------------------------
let LOAD_LEAD_CONVERSION_DAYS = 'LOAD_LEAD_CONVERSION_DAYS'

export function loadLeadConversionDays(filter) {
  return (dispatch, getState) => {
    return leadConverionsAnalyticsService.getLeadConversionDays(filter)
      .then((conversionDays) => {
        dispatch({
          type: LOAD_LEAD_CONVERSION_DAYS,
          conversionDays: conversionDays
        })
      })
  }
}

// ------------------------------------
// Reducer
// ------------------------------------

export function loadLeadConversionDaysReducer(state = {stores: [], products: []}, action) {
  switch (action.type) {
    case LOAD_LEAD_CONVERSION_DAYS: {
      return action.conversionDays
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/LeadConversionDaysAnalytics/modules/LeadConversionDaysAnalytics.js